exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-5-wrapper[data-v-67de58dc]{width:400px;padding-bottom:10px}.bottom-border[data-v-67de58dc]{width:calc(100% + 3px);margin-bottom:-2px;margin-top:10px;margin-left:-1px;color:#fff;padding:8px;text-align:center;font-size:15px}.listing-img[data-v-67de58dc]{width:30px;height:30px;display:inline-block;margin-right:-10px;border-radius:50%;border:3px solid #fff}", ""]);

// exports
